import { render } from "./chooseEquipment.vue?vue&type=template&id=8964dca8&scoped=true&ts=true"
import script from "./chooseEquipment.vue?vue&type=script&lang=ts"
export * from "./chooseEquipment.vue?vue&type=script&lang=ts"

import "./chooseEquipment.vue?vue&type=style&index=0&id=8964dca8&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8964dca8"]])

export default __exports__